<div *ngIf="this.loadingService.loading$ | async" class="d-flex flex-column jc-center ai-center pos-absolute"
  [ngClass]="hasBackgound() ? 'bc-loader' : 'wh-loader'">
  <div class="loader"></div>

  <div class="text-center f-s-14 text-color-white m-t-20">{{textLabel() ?? ''}}</div>
</div>